import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { ISku, ISkuInput } from "@/interfaces/sku.interface";
import { SkuFormMessages } from "@/messages/sku/sku-form.messages";

import { SkuTableRow } from "./row";
import { SKU_TABLE_COLUMNS } from "../../constants";

interface Props {
  skus: ISku[] | ISkuInput[];
  messages: SkuFormMessages;
  onRemove: (sku: ISku) => void;
  addSkuClick: () => void;
  openDialog: (isEditing: boolean) => void;
}

export function SkuTable({ skus, messages, onRemove, addSkuClick, openDialog }: Props) {
  const columns = SKU_TABLE_COLUMNS(messages);

  return (
    <MDBox>
      <MDBox display="flex" justifyContent="space-between" alignItems={"center"}>
        <MDTypography variant="h5" fontWeight="bold">
          {messages.titleSku}
        </MDTypography>

        <MDButton variant="gradient" color="dark" onClick={addSkuClick}>
          {messages.createButton}
        </MDButton>
      </MDBox>

      <MDBox mt={1}>
        <Grid container spacing={3}>
          <TableContainer sx={{ marginTop: 1 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableHeaderRow>
                  {columns.map((label, index) => (
                    <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
                  ))}
                </TableHeaderRow>
              </TableHead>

              <TableBody>
                {skus && skus.length <= 0 ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <MDTypography variant="h6" color="text" fontWeight={"regular"}>
                        {messages.noSkusAdded}
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                ) : (
                  skus &&
                  skus.map((singleSku, index) => (
                    <SkuTableRow
                      key={`${index} - ${singleSku.code}`}
                      sku={singleSku as ISku}
                      index={index}
                      messages={messages}
                      onRemove={onRemove}
                      openDialog={openDialog}
                    />
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </MDBox>
    </MDBox>
  );
}
